import React from 'react';
import { WebsiteDesignProps } from './types';
import { Clapperboard, Video } from 'lucide-react';
import { Button } from "@/components/ui/button";

const FilmSchool: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Institute of Cinematic Arts";

    return (
        <div className="bg-black min-h-screen font-sans text-white">
            {/* Film Strip Border */}
            <div className="fixed left-0 top-0 bottom-0 w-8 bg-[#111] border-r border-[#333] flex flex-col justify-around py-4 z-50">
                {[...Array(20)].map((_, i) => (
                    <div key={i} className="w-4 h-3 bg-[#222] mx-auto rounded-sm"></div>
                ))}
            </div>
            <div className="fixed right-0 top-0 bottom-0 w-8 bg-[#111] border-l border-[#333] flex flex-col justify-around py-4 z-50">
                {[...Array(20)].map((_, i) => (
                    <div key={i} className="w-4 h-3 bg-[#222] mx-auto rounded-sm"></div>
                ))}
            </div>

            <div className="px-16">
                <nav className="py-8 flex justify-between items-center">
                    <div className="flex items-center gap-3 text-xl font-bold tracking-tight">
                        <Clapperboard className="text-red-600" /> {schoolName}
                    </div>
                    <div className="hidden md:flex gap-8 text-xs uppercase tracking-widest text-gray-400">
                        <a href="#" className="hover:text-white">Directing</a>
                        <a href="#" className="hover:text-white">Cinematography</a>
                        <a href="#" className="hover:text-white">Screenwriting</a>
                    </div>
                </nav>

                <header className="py-20 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                    <div>
                        <div className="inline-block bg-red-600 text-white px-3 py-1 text-xs font-bold uppercase tracking-widest mb-6">
                            Applications Open
                        </div>
                        <h1 className="text-5xl md:text-7xl font-black mb-8 leading-none tracking-tight">
                            TELL YOUR <br/> STORY.
                        </h1>
                        <p className="text-lg text-gray-400 mb-10 max-w-md leading-relaxed">
                            From concept to screen. Master the craft of filmmaking with industry professionals as your mentors.
                        </p>
                        <div className="flex gap-4">
                            <Button className="bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wider px-8 h-14">
                                Apply
                            </Button>
                            <Button variant="outline" className="border-gray-700 text-white hover:bg-white/5 font-bold uppercase tracking-wider px-8 h-14">
                                Showreel
                            </Button>
                        </div>
                    </div>

                    <div className="relative aspect-video bg-[#111] border border-[#333] overflow-hidden group">
                        <img 
                            src="https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=2059&auto=format&fit=crop" 
                            className="w-full h-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-700" 
                            alt="Film" 
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity">
                            <div className="w-20 h-20 rounded-full bg-red-600 flex items-center justify-center">
                                <Video className="ml-1" size={32} />
                            </div>
                        </div>
                        <div className="absolute bottom-0 left-0 right-0 h-1 bg-red-600"></div>
                    </div>
                </header>
            </div>
        </div>
    );
};

export default FilmSchool;
